// public settings
export const SETTINGS={
    version:"5.0.53(61)",
    pushNotes:{
        vapidPublicKey:"BM7hKOWYAlXiI2oZ1Y7JUnCohFbewBicbwkuet8Kf194JpqOUl17uX2AbpR_Pvz56Sik5-S335RjcOXiRUv1RBM",
    },
}